import React from 'react';
import {useNavigate} from 'react-router-dom';
import {Link} from 'react-router-dom';
import {MultilineInput} from 'react-input-multiline';

export const Empresa = (props) => {
	/* Destructuring the props object. */
	const {setPantallaPerfil, selectEmpresa, empresa} = props;

	/* A hook that allows you to navigate to a different route. */
	const nav = useNavigate();
	/**
	 * It redirects the user to the company's website.
	 */
	const navigate = () => {
		console.log('redirigiento');
		nav('https://' + empresa.webEmpresa);
	};

	/**
	 * When the user clicks on the button, the function will set the state of the variable
	 * pantallaPerfil to true and the state of the variable idEmpresa to the value of the variable
	 * IdEmpresa.
	 */
	const openEmpresa = () => {
		selectEmpresa(empresa.id);
		setPantallaPerfil(true);
	};

	return (
		<div
			className='cardEmpresa'
			onClick={() => openEmpresa()}
		>
			<div className='fotoUsuario centradorLeft'>
				<div className='fotoUsu'>
					<img src='' />
				</div>
				<div className='nombreIdUsuario '>
					<div className='nombreUsuario'>{empresa.nombreEmpresa}</div>
					<div className='webEmpresa'>
						<b>
							Web :
							<a
								target='_blank'
								href={'https://' + empresa.webEmpresa}
							>
								{' ' + empresa.webEmpresa}
							</a>
						</b>
					</div>
				</div>
			</div>
			<div className='datosUsuario centradorLeft'>
				<div className='direccionUsuario'>
					<b>Email : </b>
					{empresa.emailEmpresa}
				</div>
				<div className='telefonoUsuario'>
					<b>Teléfono : </b>
					{empresa.telefono}
				</div>
			</div>
			<div className='datosUsuario centradorLeft'>
				<div className='telefonoUsuario'>
					<b>Nombre contacto: </b>
					{empresa.nombreContactoEmpresa}
				</div>
				<div className='direccionUsuario'>
					<b>Apellidos contacto: </b>
					{empresa.apellidosContactoEmpresa}
				</div>
			</div>
		</div>
	);
};
